import Vue from 'vue'

export default {
  data() {
    return {
			edited: false,
      quantities: {

      },
      quantityMin: 1,
      quantityMax: 9,
      quantityBase: 1,
    }
  },
  methods: {
    quantityItemAdd(item) {
      if (item.quantity < this.quantityMax) {
				this.edited = true;
        item.quantity++
        Vue.set(this.quantities, item.id, item.quantity)
      }
    },
    quantityItemSubstract(item) {
      if (item.quantity > this.quantityMin) {
				this.edited = true;
        item.quantity--
        Vue.set(this.quantities, item.id, item.quantity)
      }
    },
    quantityItemSet(item) {
      Vue.set(this.quantities, item.id, item.quantity)
    },
    quantityItemReset() {
      Vue.set(this, "quantities", {})
    },
    
    quantityItemGet(id) {
			return this.quantities[id] != null
				? this.quantities[id]
				: this.quantityBase
    }
  },
  mounted() {
    //this.$eventHub.$on('resetStore', this.quantityItemReset)
  }
}